import { useState } from "react";
import { MdClose } from "react-icons/md";
import Button from "components/button";
import { Select } from "components/fields";

const DEFAULT_FILTERS = { type: "all", schedule: "all", person: "all" };

const capitalize = (value) => value.charAt(0).toUpperCase() + value.slice(1);

/**
 * Filters the calendar by service type, schedule and assigned person.
 */
const QuickFilters = ({ onFilterChange, churchServices = [] }) => {
  const [filters, setFilters] = useState(DEFAULT_FILTERS);

  const serviceTypes = [
    ...new Set(
      churchServices
        .map((s) => s?.type)
        .filter(Boolean)
        .map((t) => t.toLowerCase())
    ),
  ];

  const scheduleTypes = [
    ...new Set(churchServices.map((s) => s?.schedule).filter(Boolean)),
  ];

  const assignedPeople = [
    ...new Map(
      churchServices
        .flatMap((s) => s?.users || [])
        .filter(Boolean)
        .map((user) => [user.id, user])
    ).values(),
  ];

  const updateFilters = (newFilters) => {
    setFilters(newFilters);
    onFilterChange?.(newFilters);
  };

  const handleFilterChange = (filterType, value) => {
    updateFilters({ ...filters, [filterType]: value });
  };

  const hasActiveFilters =
    filters.type !== "all" || filters.schedule !== "all" || filters.person !== "all";

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Select
        aria-label="Service type"
        className="w-full sm:w-44"
        value={filters.type}
        onChange={(e) => handleFilterChange("type", e.target.value)}
      >
        <option value="all">All Types</option>
        {serviceTypes.map((type) => (
          <option key={type} value={type}>
            {capitalize(type)}
          </option>
        ))}
      </Select>

      <Select
        aria-label="Schedule"
        className="w-full sm:w-44"
        value={filters.schedule}
        onChange={(e) => handleFilterChange("schedule", e.target.value)}
      >
        <option value="all">All Schedules</option>
        {scheduleTypes.map((schedule) => (
          <option key={schedule} value={schedule}>
            {capitalize(schedule)}
          </option>
        ))}
      </Select>

      <Select
        aria-label="Assigned person"
        className="w-full sm:w-52"
        value={filters.person}
        onChange={(e) => handleFilterChange("person", e.target.value)}
      >
        <option value="all">All People</option>
        {assignedPeople.map((person) => (
          <option key={person.id} value={person.id}>
            {person.firstName} {person.lastName}
          </option>
        ))}
      </Select>

      {hasActiveFilters && (
        <Button
          variant="ghost"
          leftIcon={<MdClose aria-hidden="true" />}
          onClick={() => updateFilters(DEFAULT_FILTERS)}
        >
          Clear Filters
        </Button>
      )}
    </div>
  );
};

export default QuickFilters;
